import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { AtxRouterTabsComponent } from './components';
import { AtxRouterTabsService } from './services';
import { FiltersPipe } from '../pipes/filters/filters.pipe';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        HttpClientModule,
    ],
    declarations: [
        FiltersPipe,
        AtxRouterTabsComponent,
    ],
    providers: [
        AtxRouterTabsService,
    ],
    exports: [
        AtxRouterTabsComponent,
    ],
})

export class AtxRouterTabsModule {}
